import React from 'react';
import TicBox from './TicBox';
import { connect } from 'react-redux';
import { playTurn } from '../../redux/actions';

const TicBoard = (props) => {
  const playingTurn = (i, j) => {
    if (props.myIdentity.id !== props.activePlayer) {
      alert('Not your turn')
      return;
    }
    const grid = [...props.grid];
    if (!grid[i][j] && !props.gameWinner) {
      grid[i][j] = props.activePlayer;
      const totalTurns = props.totalTurns + 1;
    let gameWinner = false;
    if (totalTurns >= props.streak) {
      if (isWinningPosition(i, j, grid)) {
        gameWinner = props.activePlayer
      };
    }
    if (!gameWinner && props.totalTurns === (props.gridSize * props.gridSize)) {
      gameWinner = 'Draw'
    }
    const activePlayer = props.activePlayer ==='X' ? 'O': 'X';
    props.playTurn({ grid, activePlayer, gameWinner, totalTurns })
    }
    
  }
  const isWinningPosition = (X, Y, grid) => {
    // const grid = props.grid;
    let adjPostions = 1;
    let i = X -1;
    let j = Y;
    while(i >= 0 && grid[i][j] === props.activePlayer && adjPostions < props.streak) {
      i--;
      adjPostions++;

    }
    if (adjPostions === props.streak)
      return true;
    i = X +1;
    while(i < grid.length && grid[i][j] === props.activePlayer && adjPostions < props.streak) {
      i++;
      adjPostions++;
    }
    if (adjPostions === props.streak)
      return true;
    j = Y - 1;
    i = X;
    adjPostions = 1;
    while( j >= 0 && grid[i][j] === props.activePlayer && adjPostions < props.streak) {
      j--;
      adjPostions++;

    }
    if (adjPostions === props.streak)
      return true;
    j= Y + 1;
    while(j < grid[i].length && grid[i][j] === props.activePlayer && adjPostions < props.streak) {
      j++;
      adjPostions++;
    }
    if (adjPostions === props.streak)
      return true;
    
    i = X - 1;
    j = Y - 1;
    adjPostions = 1;
    while( j >= 0 && i >= 0 && grid[i][j] === props.activePlayer && adjPostions < props.streak) {
      j--;
      i--;
      adjPostions++;
    }
    if (adjPostions === props.streak)
      return true;
    j= Y + 1;
    i = X + 1;
    while(i < grid.length && j < grid[i].length && grid[i][j] === props.activePlayer && adjPostions < props.streak) {
      j++;
      i++;
      adjPostions++;
    }
    if (adjPostions === props.streak)
      return true;
    
    i = X - 1;
    j = Y + 1;
    adjPostions = 1;
    while(i >= 0 && j < grid[i].length && grid[i][j] === props.activePlayer && adjPostions < props.streak) {
      j++;
      i--;
      adjPostions++;
    }
    if (adjPostions === props.streak)
      return true;
    
    i = X + 1;
    j = Y - 1;
    while(i < grid.length && j >= 0 && grid[i][j] === props.activePlayer && adjPostions < props.streak) {
      j--;
      i++;
      adjPostions++;
    }
    if (adjPostions === props.streak)
      return true;
    
    return false;
  }
  return (
    <div>
      {props.grid.map((row, i) => (
        <div className='u-flex' key={i}>
        {row && row.map((column, j) => (
          <TicBox key={i + '' + j} value={column} clickHandler={() => playingTurn(i, j)}/>
        ))}
        </div>
      ))}
    </div>
  )
};

const mapStateToProps = (state) => {
  
  return {
    grid: state.grid,
    activePlayer: state.activePlayer,
    streak: state.streak,
    gridSize: state.gridSize,
    totalTurns: state.totalTurns,
    gameWinner: state.gameWinner,
    myIdentity: state.myIdentity
  }
}

const mapDispatchToProps = dispatch => {
  return {
    playTurn: (payload) => dispatch(playTurn(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TicBoard);

